import { render, staticRenderFns } from "./UiLabel.vue?vue&type=template&id=4486294a&lang=pug&"
import script from "./UiLabel.vue?vue&type=script&lang=js&"
export * from "./UiLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports